<template>
  <div>
    <el-table :data="backupList.result.bakupList" height="400" v-loading="loading">
      <el-table-column type="index"></el-table-column>
      <!--<el-table-column prop="name" label="备份名称"></el-table-column>-->
      <el-table-column prop="backupAt" label="备份时间" sortable></el-table-column>
      <!--<el-table-column label="操作">-->
        <!--<el-button type="primary" @click="restoreBackup" size="small" >还原</el-button>-->
        <!--<el-button type="danger" @click="deleteBackup" size="small">删除</el-button>-->
      <!--</el-table-column>-->
    </el-table>
    <el-button type="primary" style="margin-top: 15px" @click="addBackup">添加备份</el-button>
  </div>
</template>

<script>
export default {
  name: 'DatabaseBackup',
  data () {
    return {
      // 数据库备份
      DatabaseBackup: {
        "version": 1,
        "method": "other.DatabaseBackup",
        "params": null,
        "token": "#",
        "id": 0
      },
      // 获取备份记录
      DisplayBackupRecord:{
        "version": 1,
        "method": "other.DisplayBackupRecord",
        "params": null,
        "token": "#",
        "id": 0
      },
      loading: false,
      // 备份列表
      backupList:{
        "version": 1,
        "result":{
          "bakupList":[{
              "backupId":"",
              "backupAt":"",
            }]
        },
        "id": 0
      },
      // dbBackup:[
      //   {name:'backup_20190101_441411',time:'2019-01-01'},
      //   {name:'backup_20190101_441441',time:'2019-01-01'},
      //   {name:'backup_20190101_441411',time:'2019-01-01'},
      //   {name:'backup_20190301_447571',time:'2019-03-01'},
      //   {name:'backup_20190101_465433',time:'2019-01-01'},
      //   {name:'backup_20190101_131231',time:'2019-01-01'},
      //   {name:'backup_20190101_763362',time:'2019-01-01'},
      //   {name:'backup_20190102_414114',time:'2019-01-02'},
      //   {name:'backup_20190101_733636',time:'2019-01-01'},
      //   {name:'backup_20190105_636366',time:'2019-01-05'},
      //   {name:'backup_20190101_984745',time:'2019-01-01'},
      // ]
    }
  },
  methods: {
    // 添加备份
    addBackup(){
      this.loading = true;
      this.DatabaseBackup.token = this.$store.state.token;
      console.log('备份数据库请求');
      console.log(this.DatabaseBackup);
      this.$axios.post(this.$mainUrl, this.DatabaseBackup).then(res=>{
        this.loading = false;
        console.log('备份数据库请求得到响应')
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.$message({
            type: 'success',
            message: '备份数据库成功'
          })
          this.displayBackupRecord();
        }else{
          this.$message({
            type: 'error',
            message: '备份数据库失败，' + res.data.error.message
          })
        }
      })
      // this.loading = true;
      // setTimeout(() => {
      //   this.loading = false;
      //   this.$message({
      //     type: 'success',
      //     message: '添加备份成功'
      //   })
      // }, 1000);
    },
    // 查看备份记录
    displayBackupRecord(){
      this.DisplayBackupRecord.token = this.$store.state.token;
      console.log('查看备份记录请求');
      console.log(this.DisplayBackupRecord);
      this.$axios.post(this.$mainUrl, this.DisplayBackupRecord).then(res=>{
        this.loading = false;
        console.log('查看备份记录请求得到响应')
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.$message({
            type: 'success',
            message: '查看备份记录请求'
          })
          // this.backupList = res.data;
          this.backupList.result.bakupList = [];
          console.log(res.data.result.backupList);
          console.log(res.data.result.backupList.length);
          res.data.result.backupList.forEach(item=>{
            console.log(item);
            let t = {backupAt:''};
            t.backupAt = item;
            this.backupList.result.bakupList.push(t);
          })
        }else{
          this.$message({
            type: 'error',
            message: '获取维修记录失败，' + res.data.error.message
          })
        }
      }).catch(error=>{
        this.$message({
          type: error,
          message: error
        })
      })
    },
    deleteBackup(){
      this.$message({
        type:'success',
        message: '删除成功'
      })
    },
    restoreBackup(){
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.$message({
          type: 'success',
          message: '还原成功'
        })
      }, 1000);

    }
  },
  mounted(){
    this.displayBackupRecord();
  }
}
</script>

<style scoped>

</style>
